/**
 * Whether the player still owes Take the chair (F16.5 G, R17): the strategy statement and the limits that save with it. The rail offers the chair, and the welcome's last step leads to it,
 * until they are saved, so a team that skipped them is never left without a way back.
 */
import type { TeamState } from "@bsim/contracts";

export const chairOwed = (team: Pick<TeamState, "strategyStatement" | "round">): boolean =>
  team.strategyStatement === null && (team.round === null || team.round.roundNo <= 1);
